<template>
  <ReportsWrapper :report="report" data-test-id="call-reports-total">
    <div class="mt-2">
        <DurationChart :items="report.items" :logarithmic="logarithmic" :key="`logarithmic-key-${!!logarithmic}`"/>
        <LogarithmicSwitcher v-model="logarithmic"/>
        <v-simple-table v-if="report.filters.group_by" class="mt-3 nowrap" data-test-id="total-table">
            <thead data-test-id="table-head">
              <tr data-test-id="head-row">
                <th style="width: 100%" data-test-id="fitler">{{ upperFirstCase(report.filters.group_by) }} {{ $l.t('app.from-to', 'from-to') }} [H:MM:SS]</th>
                <th data-test-id="calls">{{ $l.t('app.total-calls', 'Total calls') }}</th>
              </tr>
            </thead>
            <tbody data-test-id="table-body">
              <tr v-for="(item, i) in report.items" :data-test-id="`total-item-${i}-row`" :key="`total-item-${i}-row`">
                  <td data-test-id="value">
                    <span >{{ item.duration }}</span>
                  </td>
                  <td data-test-id="total">{{ item.total }}</td>
              </tr>
            </tbody>
        </v-simple-table>
    </div>
  </ReportsWrapper>
</template>

<script>
  import { vueComponent } from '../../../../libs/helpers2';
  import { upperFirstCase } from '../../../../libs/formatters';
  import Duration from '../../../../models/Duration';
  import ReportsWrapper from '../elements/ReportWrapper.vue';
  import DurationChart from '../elements/charts/Duration.vue';
  import LogarithmicSwitcher from '../../../elements/logarithmic-representation-switcher.vue';

  export default {
    components: {
      DurationChart,
      ReportsWrapper,
      LogarithmicSwitcher,
    },
    data() {
      return {
        logarithmic: false,
        report: new Duration(this.$session, vueComponent(this)),
      };
    },
    async created() {
      await this.$data.report.loadItems();
    },
    methods: {
      upperFirstCase(val) {
        return upperFirstCase(val).split('_').join(' ');
      },
    },
  };
</script>
